// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ssn-size[data-v-36ef0bdb] {\n  min-width: 115px;\n}", ""]);
// Exports
module.exports = exports;
